import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import DownloadIcon from '@mui/icons-material/Download';

import '../assets/styles/Main.scss';
import avatar from '../assets/images/avatar-600x600.png';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={avatar} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://www.linkedin.com/in/haihd/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href="https://github.com/haihd" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="mailto:dustin.dev@hotmail.com" rel="noreferrer"><EmailIcon/></a>
            <a href="/resume.pdf" target="_blank" rel="noreferrer"><DownloadIcon/></a>
          </div>
          <h1>Hai Ha Dai (Dustin)</h1>
          <p>Full Stack Software Engineer</p>

          <div className="mobile_social_icons">
            <a href="https://www.linkedin.com/in/haihd/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href="https://github.com/haihd" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="mailto:dustin.dev@hotmail.com" rel="noreferrer"><EmailIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;